/** Inputs for a privacy-safe worker pay record leaf hash. Never includes names, rates, or notes. */
export interface WorkerPayRecordInput {
  companyId: string;
  payPeriodId: string;
  employeeId: string;
  regularHours: number;
  overtimeHours: number;
  doubleTimeHours: number;
  holidayHours: number;
  grossPay: number;
  privateSalt: string;
}

export interface PayPeriodMerkleTree {
  /** Sorted leaf hashes (worker pay record hashes). */
  leaves: string[];
  /** Merkle layers from leaves to root. */
  layers: string[][];
  root: string;
}

export interface OnchainBatchProofPayload {
  merkleRoot: string;
  payPeriodPublicRef: string;
  timestamp: string;
  transactionSignature: string | null;
  chain: string;
}

export interface OnchainPublishInput {
  merkleRoot: string;
  payPeriodPublicRef: string;
  timestamp: string;
}

export interface OnchainPublishResult {
  transactionSignature: string;
}

export interface OnchainAdapter {
  readonly chain: string;
  publish(input: OnchainPublishInput): Promise<OnchainPublishResult>;
}

/** Fields that must never appear in onchain payloads. */
export const ONCHAIN_EXCLUDED_FIELDS = [
  "employee names",
  "pay rates",
  "raw hours",
  "full payroll data",
  "notes",
  "equipment details",
] as const;

/** Fields that may be published onchain. */
export const ONCHAIN_PUBLISHED_FIELDS = [
  "merkle root",
  "pay period public reference",
  "timestamp",
  "transaction signature",
] as const;
